import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

interface CopySuccessIconProps extends SvgIconProps {
  disabled?: boolean;
}

const CopySuccessIcon = (props: CopySuccessIconProps) => {
  const { className, disabled, ...otherProps } = props;
  const fillColor = disabled ? 'rgba(255, 255, 255, 0.38)' : '#2ED2AB';

  return (
    <SvgIcon {...otherProps} className={className || ''} viewBox="0 0 16 16">
      <path
        d="M7.99992 1.33325C4.31992 1.33325 1.33325 4.31992 1.33325 7.99992C1.33325 11.6799 4.31992 14.6666 7.99992 14.6666C11.6799 14.6666 14.6666 11.6799 14.6666 7.99992C14.6666 4.31992 11.6799 1.33325 7.99992 1.33325ZM6.66659 11.3333L3.33325 7.99992L4.27325 7.05992L6.66659 9.44659L11.7266 4.38659L12.6666 5.33325L6.66659 11.3333Z"
        fill={fillColor}
      />
    </SvgIcon>
  );
};

export default CopySuccessIcon;
